import { unwrapResponse } from "../../../../response.js";
import { authHeader, postJson, acceptJson } from "../../../../shared.js";
async function quantity(apiUrl, accessToken, customerId, subscriptionId, request) {
  return unwrapResponse(
    await fetch(
      `${apiUrl}/customers/customer/${encodeURIComponent(
        customerId
      )}/subscription/${subscriptionId}/quantity`,
      {
        method: "POST",
        headers: {
          ...acceptJson,
          ...postJson,
          ...authHeader(accessToken)
        },
        body: JSON.stringify(request)
      }
    )
  );
}
export {
  quantity
};
//# sourceMappingURL=quantity.js.map
